import classNames from 'classnames';

import s from './Alert.sss';

type AlertProps = React.HTMLProps<HTMLDivElement> & {
  theme?: keyof typeof themeClassNames
};

const themeClassNames = {
  default: s.themeDefault,
  info: s.themeInfo,
  warning: s.themeWarning,
};

export const Alert: React.FC<AlertProps> = ({
  theme = 'info',
  className,
  ...props
}) => (
  <div
    {...props}
    className={classNames(s.root, themeClassNames[theme], className)}
  />
);
